import DayGridScenario from '../schema/DayGridScenario';
import { action } from 'satcheljs';

export const updateFolderIdsIfNeeded = action(
    'updateFolderIdsIfNeeded',
    (scenario: DayGridScenario, calendarIds: string[]) => ({
        scenario,
        calendarIds,
    })
);
